import apiUser from './apiUser';
import apiStaff from './apiStaff';
import auth from './auth';
import modules from './storeModules';

// 通用变量
// let userDetail = {};

// user模块通用接口和方法
export default {
  ...apiUser,
  ...apiStaff,
  ...auth,
  //
  // userDetail,
  modules,
};
